module.exports = __webpack_public_path__ + "img/az_haohuotong_logo.5ee50195.png";